import { useTranslation } from 'react-i18next';
import { useWizard } from 'react-use-wizard';

import { Button, ButtonVariant } from '@/components/form/button';

export const SelectMicroscopeStep = ({
  onSwitchBackToMobileCam,
}: {
  onSwitchBackToMobileCam: () => void;
}) => {
  const { t } = useTranslation();
  const { nextStep } = useWizard();

  return (
    <>
      <div className="py-10">
        <p className="text-black-dark">{t('calibration.step0.text1')}</p>
        <p className="text-black-dark my-2">{t('calibration.step0.text2')}</p>
        <ul className="pl-8 list-disc text-black-dark">
          <li>{t('calibration.step0.text3')}</li>
          <li>{t('calibration.step0.text4')}</li>
          <li>{t('calibration.step0.text5')}</li>
        </ul>
      </div>
      <div className="flex flex-col gap-4 md:flex-row md:justify-between">
        <Button
          classnames="underline font-bold"
          variant={ButtonVariant.Link}
          onClick={onSwitchBackToMobileCam}
        >
          {t('calibration.switchBack')}
        </Button>
        <Button onClick={nextStep}>{t('calibration.step0.start')}</Button>
      </div>
    </>
  );
};
